export class Subproduct {
    key: string;
    displayName: string;
    benefitWaitingPeriod?: string;
    benefitPercent?: string;
    cola?: boolean;
}